import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IPaycorMapEarningCodes {
  code_id: string;
  timeero_code: string;
  entityId: string;
}

const mapPaycorEarningCodes = ({ entityId, ...postData }: IPaycorMapEarningCodes) => {
  return http().post(endpoints.integrations.paycor.mapEarningCodes.replace('{legalEntityId}', entityId), postData);
};

export function useMapPaycorEarningCodes() {
  return useMutation({ mutationFn: mapPaycorEarningCodes });
}
